import * as React from 'react';

const HOST_LOCALHOST = 'localhost';
const LOCAL_API_PORT = '4000';

const hostname = window.location.hostname;

export const API_URL = hostname.includes(HOST_LOCALHOST)
  ? `${window.location.protocol}//${hostname}:${LOCAL_API_PORT}/graphql`
  : `${window.location.origin}/graphql`;

export const environment =
  hostname.includes('preprod') || hostname.includes('localhost') ? 'DEVELOPMENT' : 'PRODUCTION';

export interface IUser {
  email: string;
  name: string;
  role: string;
}

export interface IUserInfo {
  token?: string;
  user?: IUser;
}

export interface IAppConfig {
  apiUrl: string;
  userInfo?: IUserInfo;
  updateUserInfo: (token?: string, user?: IUser) => void;
  environment: string;
}

export const AppConfig = React.createContext<IAppConfig>({
  apiUrl: API_URL,
  environment,
  updateUserInfo: () => {},
});
